export const LANGUAGES = ['es', 'en'];

export const TEXTS = {
  es: {
    title: 'San Fermín Run',
    subtitle: 'Corre delante de los toros',
    play: 'Jugar',
    share: 'Compartir',
    continue: 'Continuar',
    restart: 'Reiniciar',
    home: 'Inicio',
    back: 'Volver',
    menu: 'Menú',
    record: 'Récord',
    language: 'Idioma',
    difficulty: 'Dificultad',
    chooseDifficulty: 'Elige nivel',
    chooseRunner: 'Elige corredor',
    runner: 'Corredor',
    maleRunner: 'Hombre',
    femaleRunner: 'Mujer',
    easy: 'Suave',
    normal: 'Normal',
    hard: 'Valiente',
    time: 'Tiempo',
    best: 'Mejor',
    gameOverTitle: '¡Te han pillado!',
    gameOverMessage: 'Los toros alcanzaron al corredor.',
    startHint: 'El juego de los encierros de San Fermín.',
    paused: 'Pausa',
    shareText: 'Estoy corriendo el encierro en San Fermín Run. ¿Cuánto aguantas tú?',
  },
  en: {
    title: 'San Fermín Run',
    subtitle: 'Run ahead of the bulls',
    play: 'Play',
    share: 'Share',
    continue: 'Continue',
    restart: 'Restart',
    home: 'Home',
    back: 'Back',
    menu: 'Menu',
    record: 'Record',
    language: 'Language',
    difficulty: 'Difficulty',
    chooseDifficulty: 'Choose level',
    chooseRunner: 'Choose runner',
    runner: 'Runner',
    maleRunner: 'Man',
    femaleRunner: 'Woman',
    easy: 'Easy',
    normal: 'Normal',
    hard: 'Brave',
    time: 'Time',
    best: 'Best',
    gameOverTitle: 'Caught!',
    gameOverMessage: 'The bulls reached the runner.',
    startHint: 'Tap or swipe up to jump. You can double jump.',
    paused: 'Paused',
    shareText: 'I am running the bull run in San Fermín Run. How long can you last?',
  },
};
